export const minutesToHours = (minutes: number) => {
  return (Math.round((minutes / 60) * 100) / 100).toFixed(2)
}
